import React, { Component } from "react";
import axios from "../../utils/axiosInstance";

class Search extends Component {

    state = {
        searchText: "",
        products: [],
        loading: false
    };

    searchTimeout = null;

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchText: value });

        clearTimeout(this.searchTimeout);

        if (value.length < 2) {
            this.setState({ products: [] });
            return;
        }

        this.searchTimeout = setTimeout(() => {
            this.searchProducts(value);
        }, 400);
    };

    searchProducts = async (keyword) => {

        try {
            this.setState({ loading: true });

            const res = await axios.get("/search-products", {
                params: {keyword: keyword}
            });

            this.setState({
                products: Array.isArray(res.data?.data) ? res.data.data : [],
                loading: false
            });

        } catch (error) {
            console.error("Search failed");
            this.setState({ loading: false });
        }
    };

    render() {
        const {
            searchText,
            products,
            loading
        } = this.state;

        return (
            <>
                {/* INLINE CSS */}
                <style>{`
                    .search-style-2 {
                        position: relative;
                        width: 100%;
                    }

                    .search-result-box {
                        position: absolute;
                        top: 100%;
                        left: 0;
                        width: 100%;
                        background: #fff;
                        border: 1px solid #ddd;
                        max-height: 300px;
                        overflow-y: auto;
                        z-index: 9999;
                    }

                    .search-item {
                        padding: 10px;
                        cursor: pointer;
                        font-size: 14px;
                    }

                    .search-item:hover {
                        background: #f5f5f5;
                    }
                `}</style>

                <div className="search-style-2">
                    <form onSubmit={e => e.preventDefault()}>
                        <input
                            type="text"
                            placeholder="Search for items..."
                            value={searchText}
                            onChange={this.handleSearchChange}
                            autoComplete="off"
                        />
                    </form>

                    {searchText && (
                        <div className="search-result-box">
                            {loading && (
                                <div className="search-item">Searching...</div>
                            )}

                            {!loading && products.length === 0 && (
                                <div className="search-item">No products found</div>
                            )}

                            {!loading && products.map(product => (
                                <div
                                    key={product.id}
                                    className="search-item"
                                    onClick={() =>
                                        window.location.href = `/product/${product.id}`
                                    }
                                >
                                    {product.product_name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </>
        );
    }
}

export default Search;
